import { jsx } from 'react/jsx-runtime';
import { Close } from '../../../../../../node_modules/@radix-ui/react-dialog/dist/index.js';
import { Button } from '../../../../../Button/Button.js';

const FooterButton = ({ onClick, text, ...rest }) => {
    return onClick ? (jsx(Button, { ...rest, onClick: onClick, size: "m", children: text })) : (jsx(Close, { asChild: true, children: jsx(Button, { ...rest, size: "m", children: text }) }));
};

export { FooterButton };
//# sourceMappingURL=FooterButton.js.map
